import(/* webpackMode: "eager" */ "/vercel/path0/app/casa-memory/sample/sample.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
